/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { createDialogRoute } from '@gh/common-shared';
import { DashboardManageDialogComponent } from './dashboard-manage-dialog.component';

export const dashboardManageDialogRoute = createDialogRoute({
  component: DashboardManageDialogComponent,
});
